var codeblock_default = {
  "blockStyleSpacing": "zVeWm",
  "codeBlock": "Rwuq2 zVeWm",
  "renderedInTable": "OHN2X"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
